/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as StoreIdRouteImport } from './routes/store.$id'
import { Route as AppSystemRouteImport } from './routes/_app/system'
import { Route as AppPlansRouteImport } from './routes/_app/plans'
import { Route as AppDocsRouteImport } from './routes/_app/docs'
import { Route as AppBillingRouteImport } from './routes/_app/billing'
import { Route as AppActivityRouteImport } from './routes/_app/activity'
import { Route as StoreIdIndexRouteImport } from './routes/store.$id.index'
import { Route as AppTenantsIndexRouteImport } from './routes/_app/tenants.index'
import { Route as StoreIdShippingRouteImport } from './routes/store.$id.shipping'
import { Route as StoreIdSettingsRouteImport } from './routes/store.$id.settings'
import { Route as StoreIdReviewsRouteImport } from './routes/store.$id.reviews'
import { Route as StoreIdReturnsRouteImport } from './routes/store.$id.returns'
import { Route as StoreIdReportsRouteImport } from './routes/store.$id.reports'
import { Route as StoreIdProductsRouteImport } from './routes/store.$id.products'
import { Route as StoreIdProductTypesRouteImport } from './routes/store.$id.product-types'
import { Route as StoreIdPaymentsRouteImport } from './routes/store.$id.payments'
import { Route as StoreIdOnboardingRouteImport } from './routes/store.$id.onboarding'
import { Route as StoreIdMarketingRouteImport } from './routes/store.$id.marketing'
import { Route as StoreIdLoyaltyRouteImport } from './routes/store.$id.loyalty'
import { Route as StoreIdInventoryRouteImport } from './routes/store.$id.inventory'
import { Route as StoreIdEmailTemplatesRouteImport } from './routes/store.$id.email-templates'
import { Route as StoreIdCouponsRouteImport } from './routes/store.$id.coupons'
import { Route as StoreIdCommentsRouteImport } from './routes/store.$id.comments'
import { Route as StoreIdCategoriesRouteImport } from './routes/store.$id.categories'
import { Route as StoreIdAuditRouteImport } from './routes/store.$id.audit'
import { Route as StoreIdAnalyticsRouteImport } from './routes/store.$id.analytics'
import { Route as AppTenantsIdRouteImport } from './routes/_app/tenants.$id'
import { Route as StoreIdOrdersIndexRouteImport } from './routes/store.$id.orders.index'
import { Route as StoreIdCustomersIndexRouteImport } from './routes/store.$id.customers.index'
import { Route as StoreIdBlogIndexRouteImport } from './routes/store.$id.blog.index'
import { Route as StoreIdOrdersOrderIdRouteImport } from './routes/store.$id.orders.$orderId'
import { Route as StoreIdCustomersCustomerIdRouteImport } from './routes/store.$id.customers.$customerId'
import { Route as StoreIdBlogPostIdRouteImport } from './routes/store.$id.blog.$postId'

const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const StoreIdRoute = StoreIdRouteImport.update({
  id: '/store/$id',
  path: '/store/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSystemRoute = AppSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppRoute,
} as any)
const AppPlansRoute = AppPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsRoute = AppDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppActivityRoute = AppActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any)
const StoreIdIndexRoute = StoreIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StoreIdRoute,
} as any)
const AppTenantsIndexRoute = AppTenantsIndexRouteImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => AppRoute,
} as any)
const StoreIdShippingRoute = StoreIdShippingRouteImport.update({
  id: '/shipping',
  path: '/shipping',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdSettingsRoute = StoreIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdReviewsRoute = StoreIdReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdReturnsRoute = StoreIdReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdReportsRoute = StoreIdReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdProductsRoute = StoreIdProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdProductTypesRoute = StoreIdProductTypesRouteImport.update({
  id: '/product-types',
  path: '/product-types',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdPaymentsRoute = StoreIdPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdOnboardingRoute = StoreIdOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdMarketingRoute = StoreIdMarketingRouteImport.update({
  id: '/marketing',
  path: '/marketing',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdLoyaltyRoute = StoreIdLoyaltyRouteImport.update({
  id: '/loyalty',
  path: '/loyalty',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdInventoryRoute = StoreIdInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdEmailTemplatesRoute = StoreIdEmailTemplatesRouteImport.update({
  id: '/email-templates',
  path: '/email-templates',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdCouponsRoute = StoreIdCouponsRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdCommentsRoute = StoreIdCommentsRouteImport.update({
  id: '/comments',
  path: '/comments',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdCategoriesRoute = StoreIdCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdAuditRoute = StoreIdAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdAnalyticsRoute = StoreIdAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => StoreIdRoute,
} as any)
const AppTenantsIdRoute = AppTenantsIdRouteImport.update({
  id: '/tenants/$id',
  path: '/tenants/$id',
  getParentRoute: () => AppRoute,
} as any)
const StoreIdOrdersIndexRoute = StoreIdOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdCustomersIndexRoute = StoreIdCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdBlogIndexRoute = StoreIdBlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdOrdersOrderIdRoute = StoreIdOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => StoreIdRoute,
} as any)
const StoreIdCustomersCustomerIdRoute =
  StoreIdCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => StoreIdRoute,
  } as any)
const StoreIdBlogPostIdRoute = StoreIdBlogPostIdRouteImport.update({
  id: '/blog/$postId',
  path: '/blog/$postId',
  getParentRoute: () => StoreIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/activity': typeof AppActivityRoute
  '/billing': typeof AppBillingRoute
  '/docs': typeof AppDocsRoute
  '/plans': typeof AppPlansRoute
  '/system': typeof AppSystemRoute
  '/store/$id': typeof StoreIdRouteWithChildren
  '/tenants/$id': typeof AppTenantsIdRoute
  '/store/$id/analytics': typeof StoreIdAnalyticsRoute
  '/store/$id/audit': typeof StoreIdAuditRoute
  '/store/$id/categories': typeof StoreIdCategoriesRoute
  '/store/$id/comments': typeof StoreIdCommentsRoute
  '/store/$id/coupons': typeof StoreIdCouponsRoute
  '/store/$id/email-templates': typeof StoreIdEmailTemplatesRoute
  '/store/$id/inventory': typeof StoreIdInventoryRoute
  '/store/$id/loyalty': typeof StoreIdLoyaltyRoute
  '/store/$id/marketing': typeof StoreIdMarketingRoute
  '/store/$id/onboarding': typeof StoreIdOnboardingRoute
  '/store/$id/payments': typeof StoreIdPaymentsRoute
  '/store/$id/product-types': typeof StoreIdProductTypesRoute
  '/store/$id/products': typeof StoreIdProductsRoute
  '/store/$id/reports': typeof StoreIdReportsRoute
  '/store/$id/returns': typeof StoreIdReturnsRoute
  '/store/$id/reviews': typeof StoreIdReviewsRoute
  '/store/$id/settings': typeof StoreIdSettingsRoute
  '/store/$id/shipping': typeof StoreIdShippingRoute
  '/tenants/': typeof AppTenantsIndexRoute
  '/store/$id/': typeof StoreIdIndexRoute
  '/store/$id/blog/$postId': typeof StoreIdBlogPostIdRoute
  '/store/$id/customers/$customerId': typeof StoreIdCustomersCustomerIdRoute
  '/store/$id/orders/$orderId': typeof StoreIdOrdersOrderIdRoute
  '/store/$id/blog/': typeof StoreIdBlogIndexRoute
  '/store/$id/customers/': typeof StoreIdCustomersIndexRoute
  '/store/$id/orders/': typeof StoreIdOrdersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/activity': typeof AppActivityRoute
  '/billing': typeof AppBillingRoute
  '/docs': typeof AppDocsRoute
  '/plans': typeof AppPlansRoute
  '/system': typeof AppSystemRoute
  '/': typeof AppIndexRoute
  '/tenants/$id': typeof AppTenantsIdRoute
  '/store/$id/analytics': typeof StoreIdAnalyticsRoute
  '/store/$id/audit': typeof StoreIdAuditRoute
  '/store/$id/categories': typeof StoreIdCategoriesRoute
  '/store/$id/comments': typeof StoreIdCommentsRoute
  '/store/$id/coupons': typeof StoreIdCouponsRoute
  '/store/$id/email-templates': typeof StoreIdEmailTemplatesRoute
  '/store/$id/inventory': typeof StoreIdInventoryRoute
  '/store/$id/loyalty': typeof StoreIdLoyaltyRoute
  '/store/$id/marketing': typeof StoreIdMarketingRoute
  '/store/$id/onboarding': typeof StoreIdOnboardingRoute
  '/store/$id/payments': typeof StoreIdPaymentsRoute
  '/store/$id/product-types': typeof StoreIdProductTypesRoute
  '/store/$id/products': typeof StoreIdProductsRoute
  '/store/$id/reports': typeof StoreIdReportsRoute
  '/store/$id/returns': typeof StoreIdReturnsRoute
  '/store/$id/reviews': typeof StoreIdReviewsRoute
  '/store/$id/settings': typeof StoreIdSettingsRoute
  '/store/$id/shipping': typeof StoreIdShippingRoute
  '/tenants': typeof AppTenantsIndexRoute
  '/store/$id': typeof StoreIdIndexRoute
  '/store/$id/blog/$postId': typeof StoreIdBlogPostIdRoute
  '/store/$id/customers/$customerId': typeof StoreIdCustomersCustomerIdRoute
  '/store/$id/orders/$orderId': typeof StoreIdOrdersOrderIdRoute
  '/store/$id/blog': typeof StoreIdBlogIndexRoute
  '/store/$id/customers': typeof StoreIdCustomersIndexRoute
  '/store/$id/orders': typeof StoreIdOrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/_app/activity': typeof AppActivityRoute
  '/_app/billing': typeof AppBillingRoute
  '/_app/docs': typeof AppDocsRoute
  '/_app/plans': typeof AppPlansRoute
  '/_app/system': typeof AppSystemRoute
  '/store/$id': typeof StoreIdRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/tenants/$id': typeof AppTenantsIdRoute
  '/store/$id/analytics': typeof StoreIdAnalyticsRoute
  '/store/$id/audit': typeof StoreIdAuditRoute
  '/store/$id/categories': typeof StoreIdCategoriesRoute
  '/store/$id/comments': typeof StoreIdCommentsRoute
  '/store/$id/coupons': typeof StoreIdCouponsRoute
  '/store/$id/email-templates': typeof StoreIdEmailTemplatesRoute
  '/store/$id/inventory': typeof StoreIdInventoryRoute
  '/store/$id/loyalty': typeof StoreIdLoyaltyRoute
  '/store/$id/marketing': typeof StoreIdMarketingRoute
  '/store/$id/onboarding': typeof StoreIdOnboardingRoute
  '/store/$id/payments': typeof StoreIdPaymentsRoute
  '/store/$id/product-types': typeof StoreIdProductTypesRoute
  '/store/$id/products': typeof StoreIdProductsRoute
  '/store/$id/reports': typeof StoreIdReportsRoute
  '/store/$id/returns': typeof StoreIdReturnsRoute
  '/store/$id/reviews': typeof StoreIdReviewsRoute
  '/store/$id/settings': typeof StoreIdSettingsRoute
  '/store/$id/shipping': typeof StoreIdShippingRoute
  '/_app/tenants/': typeof AppTenantsIndexRoute
  '/store/$id/': typeof StoreIdIndexRoute
  '/store/$id/blog/$postId': typeof StoreIdBlogPostIdRoute
  '/store/$id/customers/$customerId': typeof StoreIdCustomersCustomerIdRoute
  '/store/$id/orders/$orderId': typeof StoreIdOrdersOrderIdRoute
  '/store/$id/blog/': typeof StoreIdBlogIndexRoute
  '/store/$id/customers/': typeof StoreIdCustomersIndexRoute
  '/store/$id/orders/': typeof StoreIdOrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/setup'
    | '/activity'
    | '/billing'
    | '/docs'
    | '/plans'
    | '/system'
    | '/store/$id'
    | '/tenants/$id'
    | '/store/$id/analytics'
    | '/store/$id/audit'
    | '/store/$id/categories'
    | '/store/$id/comments'
    | '/store/$id/coupons'
    | '/store/$id/email-templates'
    | '/store/$id/inventory'
    | '/store/$id/loyalty'
    | '/store/$id/marketing'
    | '/store/$id/onboarding'
    | '/store/$id/payments'
    | '/store/$id/product-types'
    | '/store/$id/products'
    | '/store/$id/reports'
    | '/store/$id/returns'
    | '/store/$id/reviews'
    | '/store/$id/settings'
    | '/store/$id/shipping'
    | '/tenants/'
    | '/store/$id/'
    | '/store/$id/blog/$postId'
    | '/store/$id/customers/$customerId'
    | '/store/$id/orders/$orderId'
    | '/store/$id/blog/'
    | '/store/$id/customers/'
    | '/store/$id/orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/setup'
    | '/activity'
    | '/billing'
    | '/docs'
    | '/plans'
    | '/system'
    | '/'
    | '/tenants/$id'
    | '/store/$id/analytics'
    | '/store/$id/audit'
    | '/store/$id/categories'
    | '/store/$id/comments'
    | '/store/$id/coupons'
    | '/store/$id/email-templates'
    | '/store/$id/inventory'
    | '/store/$id/loyalty'
    | '/store/$id/marketing'
    | '/store/$id/onboarding'
    | '/store/$id/payments'
    | '/store/$id/product-types'
    | '/store/$id/products'
    | '/store/$id/reports'
    | '/store/$id/returns'
    | '/store/$id/reviews'
    | '/store/$id/settings'
    | '/store/$id/shipping'
    | '/tenants'
    | '/store/$id'
    | '/store/$id/blog/$postId'
    | '/store/$id/customers/$customerId'
    | '/store/$id/orders/$orderId'
    | '/store/$id/blog'
    | '/store/$id/customers'
    | '/store/$id/orders'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/setup'
    | '/_app/activity'
    | '/_app/billing'
    | '/_app/docs'
    | '/_app/plans'
    | '/_app/system'
    | '/store/$id'
    | '/_app/'
    | '/_app/tenants/$id'
    | '/store/$id/analytics'
    | '/store/$id/audit'
    | '/store/$id/categories'
    | '/store/$id/comments'
    | '/store/$id/coupons'
    | '/store/$id/email-templates'
    | '/store/$id/inventory'
    | '/store/$id/loyalty'
    | '/store/$id/marketing'
    | '/store/$id/onboarding'
    | '/store/$id/payments'
    | '/store/$id/product-types'
    | '/store/$id/products'
    | '/store/$id/reports'
    | '/store/$id/returns'
    | '/store/$id/reviews'
    | '/store/$id/settings'
    | '/store/$id/shipping'
    | '/_app/tenants/'
    | '/store/$id/'
    | '/store/$id/blog/$postId'
    | '/store/$id/customers/$customerId'
    | '/store/$id/orders/$orderId'
    | '/store/$id/blog/'
    | '/store/$id/customers/'
    | '/store/$id/orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  SetupRoute: typeof SetupRoute
  StoreIdRoute: typeof StoreIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/store/$id': {
      id: '/store/$id'
      path: '/store/$id'
      fullPath: '/store/$id'
      preLoaderRoute: typeof StoreIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/system': {
      id: '/_app/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof AppSystemRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plans': {
      id: '/_app/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof AppPlansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs': {
      id: '/_app/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof AppDocsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing': {
      id: '/_app/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/store/$id/': {
      id: '/store/$id/'
      path: '/'
      fullPath: '/store/$id/'
      preLoaderRoute: typeof StoreIdIndexRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/_app/tenants/': {
      id: '/_app/tenants/'
      path: '/tenants'
      fullPath: '/tenants/'
      preLoaderRoute: typeof AppTenantsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/store/$id/shipping': {
      id: '/store/$id/shipping'
      path: '/shipping'
      fullPath: '/store/$id/shipping'
      preLoaderRoute: typeof StoreIdShippingRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/settings': {
      id: '/store/$id/settings'
      path: '/settings'
      fullPath: '/store/$id/settings'
      preLoaderRoute: typeof StoreIdSettingsRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/reviews': {
      id: '/store/$id/reviews'
      path: '/reviews'
      fullPath: '/store/$id/reviews'
      preLoaderRoute: typeof StoreIdReviewsRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/returns': {
      id: '/store/$id/returns'
      path: '/returns'
      fullPath: '/store/$id/returns'
      preLoaderRoute: typeof StoreIdReturnsRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/reports': {
      id: '/store/$id/reports'
      path: '/reports'
      fullPath: '/store/$id/reports'
      preLoaderRoute: typeof StoreIdReportsRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/products': {
      id: '/store/$id/products'
      path: '/products'
      fullPath: '/store/$id/products'
      preLoaderRoute: typeof StoreIdProductsRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/product-types': {
      id: '/store/$id/product-types'
      path: '/product-types'
      fullPath: '/store/$id/product-types'
      preLoaderRoute: typeof StoreIdProductTypesRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/payments': {
      id: '/store/$id/payments'
      path: '/payments'
      fullPath: '/store/$id/payments'
      preLoaderRoute: typeof StoreIdPaymentsRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/onboarding': {
      id: '/store/$id/onboarding'
      path: '/onboarding'
      fullPath: '/store/$id/onboarding'
      preLoaderRoute: typeof StoreIdOnboardingRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/marketing': {
      id: '/store/$id/marketing'
      path: '/marketing'
      fullPath: '/store/$id/marketing'
      preLoaderRoute: typeof StoreIdMarketingRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/loyalty': {
      id: '/store/$id/loyalty'
      path: '/loyalty'
      fullPath: '/store/$id/loyalty'
      preLoaderRoute: typeof StoreIdLoyaltyRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/inventory': {
      id: '/store/$id/inventory'
      path: '/inventory'
      fullPath: '/store/$id/inventory'
      preLoaderRoute: typeof StoreIdInventoryRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/email-templates': {
      id: '/store/$id/email-templates'
      path: '/email-templates'
      fullPath: '/store/$id/email-templates'
      preLoaderRoute: typeof StoreIdEmailTemplatesRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/coupons': {
      id: '/store/$id/coupons'
      path: '/coupons'
      fullPath: '/store/$id/coupons'
      preLoaderRoute: typeof StoreIdCouponsRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/comments': {
      id: '/store/$id/comments'
      path: '/comments'
      fullPath: '/store/$id/comments'
      preLoaderRoute: typeof StoreIdCommentsRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/categories': {
      id: '/store/$id/categories'
      path: '/categories'
      fullPath: '/store/$id/categories'
      preLoaderRoute: typeof StoreIdCategoriesRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/audit': {
      id: '/store/$id/audit'
      path: '/audit'
      fullPath: '/store/$id/audit'
      preLoaderRoute: typeof StoreIdAuditRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/analytics': {
      id: '/store/$id/analytics'
      path: '/analytics'
      fullPath: '/store/$id/analytics'
      preLoaderRoute: typeof StoreIdAnalyticsRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/_app/tenants/$id': {
      id: '/_app/tenants/$id'
      path: '/tenants/$id'
      fullPath: '/tenants/$id'
      preLoaderRoute: typeof AppTenantsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/store/$id/orders/': {
      id: '/store/$id/orders/'
      path: '/orders'
      fullPath: '/store/$id/orders/'
      preLoaderRoute: typeof StoreIdOrdersIndexRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/customers/': {
      id: '/store/$id/customers/'
      path: '/customers'
      fullPath: '/store/$id/customers/'
      preLoaderRoute: typeof StoreIdCustomersIndexRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/blog/': {
      id: '/store/$id/blog/'
      path: '/blog'
      fullPath: '/store/$id/blog/'
      preLoaderRoute: typeof StoreIdBlogIndexRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/orders/$orderId': {
      id: '/store/$id/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/store/$id/orders/$orderId'
      preLoaderRoute: typeof StoreIdOrdersOrderIdRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/customers/$customerId': {
      id: '/store/$id/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/store/$id/customers/$customerId'
      preLoaderRoute: typeof StoreIdCustomersCustomerIdRouteImport
      parentRoute: typeof StoreIdRoute
    }
    '/store/$id/blog/$postId': {
      id: '/store/$id/blog/$postId'
      path: '/blog/$postId'
      fullPath: '/store/$id/blog/$postId'
      preLoaderRoute: typeof StoreIdBlogPostIdRouteImport
      parentRoute: typeof StoreIdRoute
    }
  }
}

interface AppRouteChildren {
  AppActivityRoute: typeof AppActivityRoute
  AppBillingRoute: typeof AppBillingRoute
  AppDocsRoute: typeof AppDocsRoute
  AppPlansRoute: typeof AppPlansRoute
  AppSystemRoute: typeof AppSystemRoute
  AppIndexRoute: typeof AppIndexRoute
  AppTenantsIdRoute: typeof AppTenantsIdRoute
  AppTenantsIndexRoute: typeof AppTenantsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActivityRoute: AppActivityRoute,
  AppBillingRoute: AppBillingRoute,
  AppDocsRoute: AppDocsRoute,
  AppPlansRoute: AppPlansRoute,
  AppSystemRoute: AppSystemRoute,
  AppIndexRoute: AppIndexRoute,
  AppTenantsIdRoute: AppTenantsIdRoute,
  AppTenantsIndexRoute: AppTenantsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface StoreIdRouteChildren {
  StoreIdAnalyticsRoute: typeof StoreIdAnalyticsRoute
  StoreIdAuditRoute: typeof StoreIdAuditRoute
  StoreIdCategoriesRoute: typeof StoreIdCategoriesRoute
  StoreIdCommentsRoute: typeof StoreIdCommentsRoute
  StoreIdCouponsRoute: typeof StoreIdCouponsRoute
  StoreIdEmailTemplatesRoute: typeof StoreIdEmailTemplatesRoute
  StoreIdInventoryRoute: typeof StoreIdInventoryRoute
  StoreIdLoyaltyRoute: typeof StoreIdLoyaltyRoute
  StoreIdMarketingRoute: typeof StoreIdMarketingRoute
  StoreIdOnboardingRoute: typeof StoreIdOnboardingRoute
  StoreIdPaymentsRoute: typeof StoreIdPaymentsRoute
  StoreIdProductTypesRoute: typeof StoreIdProductTypesRoute
  StoreIdProductsRoute: typeof StoreIdProductsRoute
  StoreIdReportsRoute: typeof StoreIdReportsRoute
  StoreIdReturnsRoute: typeof StoreIdReturnsRoute
  StoreIdReviewsRoute: typeof StoreIdReviewsRoute
  StoreIdSettingsRoute: typeof StoreIdSettingsRoute
  StoreIdShippingRoute: typeof StoreIdShippingRoute
  StoreIdIndexRoute: typeof StoreIdIndexRoute
  StoreIdBlogPostIdRoute: typeof StoreIdBlogPostIdRoute
  StoreIdCustomersCustomerIdRoute: typeof StoreIdCustomersCustomerIdRoute
  StoreIdOrdersOrderIdRoute: typeof StoreIdOrdersOrderIdRoute
  StoreIdBlogIndexRoute: typeof StoreIdBlogIndexRoute
  StoreIdCustomersIndexRoute: typeof StoreIdCustomersIndexRoute
  StoreIdOrdersIndexRoute: typeof StoreIdOrdersIndexRoute
}

const StoreIdRouteChildren: StoreIdRouteChildren = {
  StoreIdAnalyticsRoute: StoreIdAnalyticsRoute,
  StoreIdAuditRoute: StoreIdAuditRoute,
  StoreIdCategoriesRoute: StoreIdCategoriesRoute,
  StoreIdCommentsRoute: StoreIdCommentsRoute,
  StoreIdCouponsRoute: StoreIdCouponsRoute,
  StoreIdEmailTemplatesRoute: StoreIdEmailTemplatesRoute,
  StoreIdInventoryRoute: StoreIdInventoryRoute,
  StoreIdLoyaltyRoute: StoreIdLoyaltyRoute,
  StoreIdMarketingRoute: StoreIdMarketingRoute,
  StoreIdOnboardingRoute: StoreIdOnboardingRoute,
  StoreIdPaymentsRoute: StoreIdPaymentsRoute,
  StoreIdProductTypesRoute: StoreIdProductTypesRoute,
  StoreIdProductsRoute: StoreIdProductsRoute,
  StoreIdReportsRoute: StoreIdReportsRoute,
  StoreIdReturnsRoute: StoreIdReturnsRoute,
  StoreIdReviewsRoute: StoreIdReviewsRoute,
  StoreIdSettingsRoute: StoreIdSettingsRoute,
  StoreIdShippingRoute: StoreIdShippingRoute,
  StoreIdIndexRoute: StoreIdIndexRoute,
  StoreIdBlogPostIdRoute: StoreIdBlogPostIdRoute,
  StoreIdCustomersCustomerIdRoute: StoreIdCustomersCustomerIdRoute,
  StoreIdOrdersOrderIdRoute: StoreIdOrdersOrderIdRoute,
  StoreIdBlogIndexRoute: StoreIdBlogIndexRoute,
  StoreIdCustomersIndexRoute: StoreIdCustomersIndexRoute,
  StoreIdOrdersIndexRoute: StoreIdOrdersIndexRoute,
}

const StoreIdRouteWithChildren =
  StoreIdRoute._addFileChildren(StoreIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  SetupRoute: SetupRoute,
  StoreIdRoute: StoreIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
